import { forwardRef, useState } from 'react'

/**
 * Select — native <select> styled to match the Square Code design.
 *
 * options: Array<{ value: string; label: string; disabled?: boolean }>
 * or pass children directly for full control.
 */
const Select = forwardRef(function Select(
  { error = false, options = null, children, style: styleOverride, onFocus, onBlur, disabled = false, ...rest },
  ref
) {
  const [focused, setFocused] = useState(false)
  const borderColor = error
    ? 'var(--olv-red)'
    : focused
      ? 'var(--olv-purple)'
      : 'rgba(255,255,255,0.08)'

  return (
    <select
      ref={ref}
      disabled={disabled}
      onFocus={(e) => { setFocused(true); onFocus?.(e) }}
      onBlur={(e) => { setFocused(false); onBlur?.(e) }}
      style={{
        width: '100%',
        padding: '10px 14px',
        background: disabled ? 'rgba(255,255,255,0.02)' : 'rgba(12,12,20,0.6)',
        border: `1px solid ${borderColor}`,
        borderRadius: 'var(--olv-radius-card)',
        color: disabled ? 'var(--olv-text-tertiary)' : 'var(--olv-text-primary)',
        fontSize: 13,
        fontFamily: 'var(--font-body)',
        outline: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        appearance: 'none',
        backgroundImage: 'url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 12 12\'><path d=\'M2 4l4 4 4-4\' stroke=\'%238b8fa3\' stroke-width=\'1.5\' fill=\'none\' stroke-linecap=\'round\'/></svg>")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 12px center',
        paddingRight: 32,
        backdropFilter: 'blur(8px)',
        transition: 'border-color 200ms var(--ease-standard)',
        ...styleOverride,
      }}
      {...rest}
    >
      {options
        ? options.map((opt) => (
            <option key={opt.value} value={opt.value} disabled={opt.disabled}>
              {opt.label}
            </option>
          ))
        : children}
    </select>
  )
})

export default Select
